import {gql,TypedDocumentNode} from '@apollo/client';

type StageBase = {
    description: string,
    id: string,
    order: number,
    stageStatus: 'PENDING' | 'IN_PROGRESS' | 'APPROVED' | 'REJECTED',
    title: string,
    updatedAt: Date,
}

export type NoActionStage = StageBase & {
    files?: undefined,
    rejectionMessage?: undefined,
    stageType: 'NO_ACTION',
    waitTime: number,
}

export type ApprovalStage = StageBase & {
    files?: undefined,
    rejectionMessage: string,
    stageType: 'APPROVAL',
    waitTime: number,
}

export type UploadStageFile = {title: string, type: 'pdf' | 'image', id: string, fileId: string}

export type UploadStage = StageBase & {
    files: UploadStageFile[],
    rejectionMessage?: undefined,
    stageType: 'UPLOAD',
    waitTime?: undefined,
}

export type Stage = NoActionStage | ApprovalStage | UploadStage

interface Result {
    showApplicationDetails: {
        applicationStages: Stage[],
        id: string,
        package: {
            code: string,
        },
        profile: {
            company: string
        }
        status: 'IN_PROGRESS' | 'APPROVED' | 'REJECTED',
        updatedAt: Date,
    }
}

interface Variables {
    applicationId: number,
}

export const GET_APPLICATION_DETAILS: TypedDocumentNode<Result, Variables> = gql`
    query GetApplicationDetails($applicationId: Int!) {
        showApplicationDetails(applicationId: $applicationId) {
            applicationStages {
                description
                files {
                    fileId
                    id
                    requiredFileType
                    title
                }
                id
                order
                rejectionMessage
                stageStatus
                stageType
                title
                updatedAt
                waitTime
            }
            id
            package {
                code
            }
            profile {
                company
            }
            status
            updatedAt
        }
    }       
`
